import _isFunction from "lodash/isFunction";

export function wrapArray(data) {
  if (Array.isArray(data)) {
    return data;
  }
  return [data];
}

export function wrapIdHash(raw) {
  return wrapArray(raw || []).reduce((accumulator, record) => {
    return { ...accumulator, [record.id]: record };
  }, {});
}

export function intersperseArray(array, intersperseFn) {
  const intersperseFunction = _isFunction(intersperseFn)
    ? intersperseFn
    : () => intersperseFn;

  return (array || []).reduce((interspersedArray, element, index) => {
    if (!index) {
      return [...interspersedArray, element];
    }
    return [
      ...interspersedArray,
      intersperseFunction(index, element, interspersedArray),
      element,
    ];
  }, []);
}
